import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CaseDetail from "./CaseDetail";
import useSupportTickets from "../hooks/useSupportTickets";
import {
  clearSupportActionError,
  loadSupportCaseThreadThunk,
  setSelectedSupportCase,
} from "../store/supportSlice";

const ContactSupportCase = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    cases,
    selectedCase,
    currentUserName,
    isLoadingCaseThread,
    actionError,
    handleSendReply,
    handleDownloadAttachment,
    handleEditMessage,
    handleDeleteMessage,
    handleOpenCase,
    handleCloseCase,
    handleBackToCases,
  } = useSupportTickets();

  useEffect(() => {
    if (!id) {
      navigate("/support", { replace: true });
      return;
    }

    const caseFromList = cases.find((item) => String(item.id) === String(id));
    dispatch(loadSupportCaseThreadThunk(caseFromList || { id }));

    return () => {
      dispatch(setSelectedSupportCase(null));
      dispatch(clearSupportActionError());
    };
  }, [id, dispatch, navigate]);

  const handleBack = () => {
    handleBackToCases();
    navigate("/support");
  };

  const isCurrentCase =
    selectedCase && String(selectedCase.id) === String(id);

  return (
    <div className="sm:mx-2 py-4">
      {actionError ? (
        <div className="mb-4 rounded-md border border-danger/20 bg-danger/5 px-4 py-3 text-sm text-danger">
          {actionError}
        </div>
      ) : null}

      {isLoadingCaseThread && !isCurrentCase ? (
        <div className="rounded-md border border-line bg-white px-4 py-6 text-sm text-muted">
          Loading case details...
        </div>
      ) : isCurrentCase ? (
        <CaseDetail
          caseData={selectedCase}
          currentUserName={currentUserName}
          onBack={handleBack}
          onSendReply={handleSendReply}
          onDownloadAttachment={handleDownloadAttachment}
          onCloseCase={handleCloseCase}
          isLoadingThread={isLoadingCaseThread}
          onOpenCase={handleOpenCase}
          onEditMessage={handleEditMessage}
          onDeleteMessage={handleDeleteMessage}
        />
      ) : actionError ? null : (
        <div className="rounded-md border border-line bg-white px-4 py-6 text-sm text-muted">
          Loading case details...
        </div>
      )}
    </div>
  );
};

export default ContactSupportCase;
